<template>
  <div class="gain">
    <common-layout>
      <div slot="header">
        <h3>科技成果</h3>
      </div>
      <div slot="container">
        <div class="research-search">
          <el-button
            type="success"
            icon="el-icon-plus"
            @click="addEvent"
            style="background: #623aa2; border: none"
            >新增</el-button
          >
          <el-button type="danger" icon="el-icon-delete" @click="deleteAll"
            >批量删除</el-button
          >
          <el-input
            placeholder="请输入内容"
            v-model="searchValue"
            class="input-with-select"
            @keyup.enter.native="search"
            clearable
            @clear="search"
            style="width: 240px"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="search"
            ></el-button>
          </el-input>
          <label>所属领域:</label>
          <el-select
            style="width: 140px"
            v-model="fieldValue"
            clearable
            placeholder="全部"
            @change="search"
          >
            <el-option
              v-for="item in fieldOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <label>应用行业:</label>
          <el-select
            style="width: 140px"
            v-model="tradeValue"
            clearable
            placeholder="全部"
            @change="search"
          >
            <el-option
              v-for="item in typeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <!-- <label>成果来源:</label>research
          <el-cascader
            style="width:140px"
            placeholder="请选择"
            v-model="naturalValue"
            @change='search'
            :props="{ checkStrictly: true }"
            :options="staffsOptions"
            clearable>
          </el-cascader>-->
          <!-- <el-select style="width:140px" v-model="naturalValue" clearable placeholder="全部" @change='search'>
            <el-option
              v-for="item in staffsOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>-->
          <!-- <label>技术类型:</label>
          <el-select style="width:140px" v-model="typeValue" clearable placeholder="全部" @change='search'>
            <el-option
              v-for="item in options1"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>-->
          <label>合作方式:</label>
          <el-select
            style="width: 140px"
            v-model="wayValue"
            clearable
            placeholder="全部"
            @change="search"
          >
            <el-option
              v-for="item in options2"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <div class="research-table">
          <el-table
            ref="multipleTable"
            :data="tableData"
            style="width: 100%"
            :header-cell-style="{ background: '#E5F3FE', color: '#623AA2' }"
            class="table"
            @selection-change="selectionChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>

            <el-table-column
              type="index"
              width="150"
              label="序号"
              align="center"
            >
              <template slot-scope="scope">
                <span>{{
                  scope.$index + (current_page - 1) * per_page + 1
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="名称"
              align="center"
              prop="name"
            ></el-table-column>
            <el-table-column label="简介" align="center">
              <template slot-scope="scope">
                <span style="display: block; height: 23px; overflow: hidden">{{
                  GetTarg(scope.row.introduction)
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="日期"
              align="center"
              prop="dateTime"
            ></el-table-column>
            <el-table-column label="是否推荐" align="center" prop="hot">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.hot == 1" type="success" effect="plain"
                  >是</el-tag
                >
                <el-tag v-else type="danger" effect="plain">否</el-tag>
              </template>
            </el-table-column>
            <el-table-column width="240px" align="center" label="操作">
              <template slot-scope="scope">
                <!-- <el-button
                  size="mini"
                  type="success"
                  @click="release(scope.row, 1)"
                  v-if="scope.row.hot == 2"
                >推荐资源</el-button>
                <el-button size="mini" type="warning" @click="release(scope.row, 2)" v-else>取消推荐</el-button>-->
                <el-button
                  class="mini_btn"
                  size="mini"
                  type="primary"
                  @click="handleEdit(scope.$index, scope.row)"
                  >编辑</el-button
                >
                <el-button
                  class="mini_btn"
                  size="mini"
                  type="danger"
                  @click="handleDelete(scope.$index, scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="current_page"
          :page-size="per_page"
          layout="total,prev, pager, next"
          :total="total"
          style="text-align: left; margin: 20px 0"
        ></el-pagination>
      </div>
    </common-layout>
    <el-dialog
      :title="Title"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="ruleForm" ref="ruleForm" label-width="120px">
        <el-row>
          <el-col :span="12">
            <el-row>
              <el-form-item label="成果名称" prop="name">
                <el-input
                  v-model="ruleForm.name"
                  placeholder="请输入成果名称"
                ></el-input>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="所属领域" prop="field">
                <el-select
                  multiple
                  style="width: 100%"
                  v-model="ruleForm.field"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in fieldOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="应用行业" prop="trade">
                <el-select
                  multiple
                  style="width: 100%"
                  v-model="ruleForm.trade"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in typeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="成果来源" prop="naturalArr">
                <el-cascader
                  placeholder="请填写单位名称"
                  style="width: 100%"
                  v-model="ruleForm.naturalArr"
                  :options="staffsOptions"
                  :props="{ value: 'id', label: 'name', children: 'children' }"
                  clearable
                ></el-cascader>
                <!-- <el-select
                  multiple
                  style="width:100%"
                  v-model="ruleForm.natural"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in staffsOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>-->
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-form-item label="logo" prop="logo">
              <el-upload
                class="avatar-uploader"
                :action="this.uploadURL"
                name="file"
                :show-file-list="false"
                :on-success="handlePictureCardPreview"
                :before-upload="beforeAvatarUpload"
                :http-request="HouImgFile"
              >
                <img
                  v-if="ruleForm.logo"
                  :src="imgUrl + ruleForm.logo"
                  class="img_border"
                  v-real-img="ruleForm.logo"
                />
                <i
                  v-else
                  class="el-icon-plus avatar-uploader-icon"
                  :class="{ is_border: !ruleForm.logo }"
                ></i>
                <span class="upload_btn" v-if="!ruleForm.logo">上传图片</span>
                <span v-else class="upload_btn">更换图片</span>
              </el-upload>
              <span class="del_img" v-show="ruleForm.logo">
                <i class="el-icon-error" @click="deleteImg"></i>
              </span>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <!-- <el-col :span="12">
            <el-form-item
              label="单位名称"
              prop="unit"
            >
              <el-input
                v-model="ruleForm.unit"
                placeholder="请输入单位名称"
              ></el-input>
            </el-form-item>
          </el-col>-->
          <el-col :span="12">
            <!-- <el-form-item
              label="技术类型"
              prop="type"
            >
              <el-select
                multiple
                style="width:100%"
                v-model="ruleForm.type"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in options1"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>-->
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="合作方式" prop="way">
              <el-select
                multiple
                style="width: 100%"
                v-model="ruleForm.way"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in options2"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="技术先进度" prop="advanced">
              <el-select
                multiple
                style="width: 100%"
                v-model="ruleForm.advanced"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in options4"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row>
          <el-col :span="12">
            <el-form-item
              label="技术成熟度"
              prop="mastery"
            >
              <el-select
                multiple
                style="width:100%"
                v-model="ruleForm.mastery"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in options3"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="发布时间"
              prop="pubdate"
            >
              <el-date-picker
                style="width:100%"
                v-model="ruleForm.pubdate"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>-->
        <el-row>
          <el-col :span="12">
            <el-form-item label="行业分类" prop="levelId">
              <el-cascader
                v-model="ruleForm.levelId"
                placeholder="请选择"
                :options="sortOptions"
                style="width: 100%"
                clearable
                :props="{ value: 'id', label: 'name', checkStrictly: true }"
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="个人/单位">
              <el-select style="width: 100%" v-model="ruleForm.isPerson">
                <el-option :value="1" label="个人"></el-option>
                <el-option :value="2" label="单位"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="联系人" prop="people">
              <el-input
                v-model="ruleForm.people"
                placeholder="请输入联系人"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话" prop="phone">
              <el-input
                v-model="ruleForm.phone"
                placeholder="请输入联系电话"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="ruleForm.isPerson == 2">
          <el-col :span="12">
            <el-form-item label="单位名称" prop="unit">
              <el-input
                v-model="ruleForm.unit"
                placeholder="请输入单位名称"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="单位性质" prop="unitProperties">
              <!-- <el-cascader
	            placeholder="请选择"
	            style="width:100%"
	            v-model="ruleForm.naturalArr"
	            :options="options.source"
	            :props="{ multiple: true }"
	            clearable
              ></el-cascader>-->
              <el-select
                v-model="ruleForm.unitProperties"
                placeholder="请选择"
                style="width: 100%"
                clearable
              >
                <el-option
                  v-for="item in source1"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="通讯地址" prop="detailed">
            <v-distpicker
              style="text-align: left"
              @selected="citySelected"
              :province="ruleForm.address.province.value"
              :city="ruleForm.address.city.value"
              :area="ruleForm.address.area.value"
            ></v-distpicker>
            <el-input
              style="margin-top: 10px"
              v-model="ruleForm.detailed"
              placeholder="请填写详细地址"
            ></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="实景图" style="text-align: center">
            <el-upload
              style="text-align: left"
              :action="this.uploadURL"
              list-type="picture-card"
              :file-list="fileList"
              :on-preview="pictureCardPreview1"
              :before-upload="beforeUpload1"
              :on-remove="handleRemove1"
              :http-request="HouImgFile1"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="科技成果简介" prop="introduction">
            <editor
              refName="introduction"
              :placeholderText="'请填写技术/产品概述'"
              v-model="ruleForm.introduction"
              :upload-url="uploadURL"
              :img-show-url="imgUrl"
            ></editor>
            <!-- <editor
              refName='introduction'
              :placeholder="'请填写技术/产品概述'"
              :quill-data="ruleForm.introduction"
              :upload-url="uploadURL"
              :img-show-url="imgUrl"
              @getQuillData="getQuillData"
            ></editor>-->
          </el-form-item>
        </el-row>
        <el-row>
          <el-col :span="24" class="flex-end" style="margin-bottom: 10px">
            <el-button @click="getTopKey" type="primary"
              >点击获取关键词</el-button
            >
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="5">
            <el-form-item style="text-align: left" label="是否推荐" prop="hot">
              <el-switch
                v-model="ruleForm.hot"
                :active-value="1"
                :inactive-value="2"
                active-color="#13ce66"
                inactive-color="#ff4949"
                active-text="是"
                inactive-text="否"
              ></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="推荐度" prop="hotOrder">
              <!-- <el-input v-model.number="ruleForm.hotOrder" placeholder="请输入推荐度" :disabled="ruleForm.hot == 2"></el-input> -->
              <el-slider
                v-model="ruleForm.hotOrder"
                show-input
                :disabled="ruleForm.hot == 2"
              ></el-slider>
            </el-form-item>
          </el-col>
          <el-col :span="11" style="text-align: right">
            <el-form-item label="关键字" prop="keyName">
              <el-select
                style="width: 100%"
                v-model="ruleForm.keyName"
                multiple
                filterable
                allow-create
                default-first-option
                placeholder="请选择文章标签"
                @change="changeKeyName"
              >
                <el-option
                  v-for="item in Resource_Keys"
                  :key="item.id"
                  :label="item.key"
                  :value="item.key"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeForm('ruleForm')">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false">
      <img width="100%" :src="dialogImageUrl" alt />
    </el-dialog>
  </div>
</template>

<script>
import CommonLayout from "../../components/common-layout.vue";
// import editor from "../../components/yhQuillEditor";
import editor from "../../components/tinymce-editor/tinymce-editor";
export default {
  components: {
    CommonLayout,
    editor,
  },
  data() {
    var validateHoto = (rule, value, callback) => {
      if (this.ruleForm.hot == 1) {
        if (!value) {
          callback(new Error("请设置推荐度"));
        }
        if (!Number.isInteger(value)) {
          callback(new Error("请输入数字值"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      fieldValue: "",
      tradeValue: "",
      is_submit: true,
      naturalValue: "",
      typeValue: "",
      wayValue: "",
      submit: true,
      total: 10,
      per_page: 10,
      current_page: 1,
      Title: "",
      searchValue: "",
      dialogFormVisible: false,
      dialogVisible: false,
      dialogImageUrl: "",
      deleteRow: "",
      fileList: [],
      tableData: [],
      typeOptions: [
        {
          value: "001",
          label: "农业与化工",
        },
        {
          value: "002",
          label: "生物与医药",
        },
        {
          value: "003",
          label: "能源与采矿",
        },
        {
          value: "004",
          label: "建筑与水利",
        },
        {
          value: "005",
          label: "交通与运输",
        },
        {
          value: "006",
          label: "自然与社科",
        },
      ],
      fieldOptions: [
        {
          value: "001",
          label: "新能源",
        },
        // {
        //   value: "002",
        //   label: "清洁生产",
        // },
        // {
        //   value: "003",
        //   label: "清洁能源",
        // },
        {
          value: "004",
          label: "现代农业",
        },
        {
          value: "005",
          label: "生物医药",
        },
        {
          value: "006",
          label: "文化旅游",
        },
        {
          value: "007",
          label: "通道物流",
        },
        {
          value: "008",
          label: "军民融合",
        },
        {
          value: "009",
          label: "数据信息",
        },
        {
          value: "010",
          label: "装备制造",
        },
        {
          value: '011',
          label: '新材料',
        },
      ],
      staffsOptions: [
        // {
        //   value: "001",
        //   label: "技术转移中心",
        //   children:[
        //     {
        //       value: "0011",
        //       label: "张江兰白创新改革试验区技术转移中心",
        //     },
        //     {
        //       value: "0012",
        //       label: "北京大学技术转移甘肃中心",
        //     },
        //     {
        //       value: "0013",
        //       label: "中国科学技术大学技术转移甘肃中心",
        //     },
        //     {
        //       value: "0014",
        //       label: "国家技术转移东部中心",
        //     },
        //     {
        //       value: "0015",
        //       label: "瑞士洛桑大学技术转移中心",
        //     },
        //     {
        //       value: "0016",
        //       label: "新加坡南洋理工大学技术转移中心",
        //     },
        //   ]
        // },
        // {
        //   value: "002",
        //   label: "一院三所",
        //   children:[
        //     {
        //       value: "0021",
        //       label: "中国科学院兰州化学物理研究所",
        //     },
        //     {
        //       value: "0022",
        //       label: "中国科学院近代物理研究所",
        //     },
        //     {
        //       value: "0023",
        //       label: "中国科学院寒区旱区环境与工程研究所",
        //     },
        //   ]
        // },
        // {
        //   value: "003",
        //   label: "在甘院校",
        //   children:[
        //     {
        //       value: "0031",
        //       label: "高等院校",
        //       children:[
        //         {
        //           value: "00311",
        //           label: "兰州大学",
        //         },
        //         {
        //           value: "00312",
        //           label: "兰州理工大学",
        //         },
        //         {
        //           value: "00313",
        //           label: "兰州交通大学",
        //         },
        //         {
        //           value: "00314",
        //           label: "西北民族大学",
        //         },
        //         {
        //           value: "00315",
        //           label: "甘肃农业大学",
        //         },
        //         {
        //           value: "00316",
        //           label: "兰州城市学院",
        //         },
        //         {
        //           value: "00317",
        //           label: "西北师范大学",
        //         },
        //         {
        //           value: "00318",
        //           label: "河西学院",
        //         },
        //         {
        //           value: "00319",
        //           label: "陇东学院",
        //         },
        //       ]
        //     },
        //     {
        //       value: "0032",
        //       label: "科研院所",
        //       children:[
        //         {
        //           value: "00321",
        //           label: "甘肃省科学院",
        //         },
        //         {
        //           value: "00322",
        //           label: "甘肃省农业科学院",
        //         },
        //         {
        //           value: "00323",
        //           label: "甘肃省膜科学技术研究院有限公司",
        //         },
        //         {
        //           value: "00324",
        //           label: "甘肃省科学院生物研究所",
        //         },
        //         {
        //           value: "00325",
        //           label: "甘肃省商业科技研究所",
        //         },
        //         {
        //           value: "00326",
        //           label: "甘肃省建材科研设计院",
        //         },
        //       ]
        //     }
        //   ]
        // },
        // {
        //   value: "004",
        //   label: "省属企业",
        // },
        // {
        //   value: "005",
        //   label: "省外合作机构"
        // },
        // {
        //   value: "006",
        //   label: "新型研发机构",
        //   children:[
        //     {
        //       value: '0061',
        //       label: '兰州大学白银产业技术研究院'
        //     },
        //     {
        //       value: '0062',
        //       label: '兰州理工大学白银新材料研究院'
        //     },
        //     {
        //       value: '0063',
        //       label: '甘肃西部凹凸棒石应用研究院'
        //     },
        //     {
        //       value: '0064',
        //       label: '白银市东西部协同创新研究院'
        //     },
        //     {
        //       value: '0065',
        //       label: '甘肃省陇杞中药研究院'
        //     },
        //     {
        //       value: '0066',
        //       label: '白银市实创高新产业研究院'
        //     },
        //   ]
        // },
        // {
        //   value: "007",
        //   label: "其他"
        // },
      ],
      options1: [
        {
          value: "001",
          label: "技术开发",
        },
        {
          value: "002",
          label: "技术转让",
        },
        {
          value: "003",
          label: "技术服务",
        },
        {
          value: "004",
          label: "技术咨询",
        },
      ],
      options2: [
        {
          value: "001",
          label: "委托开发",
        },
        {
          value: "002",
          label: "许可转让",
        },
        // {
        //   value: "003",
        //   label: "完全转让",
        // },
        {
          value: "008",
          label: "非专利转让",
        },
        {
          value: "009",
          label: "专利权转让",
        },
        {
          value: "010",
          label: "专利申请权转让",
        },
        {
          value: "011",
          label: "专利实施许可转让",
        },
        {
          value: "004",
          label: "技术入股",
        },
        {
          value: "005",
          label: "技术许可",
        },
        {
          value: "006",
          label: "合作转化",
        },
        // {
        //   value: "007",
        //   label: "自我转化"
        // },
        {
          value: "007",
          label: "其他",
        },
      ],
      options3: [
        {
          value: "001",
          label: "正在研发",
        },
        {
          value: "002",
          label: "已有样品",
        },
        {
          value: "003",
          label: "小试阶段",
        },
        {
          value: "004",
          label: "中试阶段",
        },
        {
          value: "005",
          label: "可以量产",
        },
      ],
      options4: [
        {
          value: "001",
          label: "国际领先",
        },
        {
          value: "002",
          label: "国际先进",
        },
        {
          value: "003",
          label: "国内领先",
        },
        {
          value: "004",
          label: "国内先进",
        },
        // {
        //   value: "005",
        //   label: "国内一般"
        // }
      ],
      source1: [
        {
          value: "001",
          label: "民营企业",
        },
        {
          value: "002",
          label: "国有企业",
        },
        {
          value: "003",
          label: "其他",
        },
      ],
      Resource_Keys: [],
      ruleForm: {
        name: "",
        logo: "",
        image: "",
        address: {
          province: {
            value: "甘肃省",
          },
          city: {
            value: "兰州市",
          },
          area: {
            value: "城关区",
          },
        },
        detailed: "",
        trade: [],
        field: [],
        naturalArr: [],
        natural: "",
        naturalSecond: "",
        naturalThird: "",
        unit: "",
        unitProperties: "",
        type: [],
        way: [],
        isPerson: 1,
        mastery: [],
        advanced: [],
        pubdate: "",
        people: "",
        phone: "",
        introduction: "",
        isShow: 1,
        hot: 2,
        hotOrder: 0,
        keyName: [],
        levelId:[]
      },
      sortOptions:[],
      rules: {
        name: [
          {
            required: true,
            message: "请输入成果名称",
            trigger: "blur",
          },
        ],

        detailed: [
          {
            validator: (rule, value, callback) =>
              this.CheckAddress(rule, value, callback, this.ruleForm),
            required: true,
            trigger: "blur",
          },
        ],
        field: [
          {
            required: true,
            message: "请选择所属领域",
            trigger: "change",
          },
        ],
        naturalArr: [
          {
            required: true,
            message: "请选择成果来源",
            trigger: "change",
          },
        ],
        unit: [
          {
            required: true,
            message: "请输入单位名称",
            trigger: "blur",
          },
        ],
        // type: [
        //   { required: true, message: "请选择技术类型", trigger: "change" }
        // ],
        // way: [
        //   { required: true, message: "请选择合作方式", trigger: "change" }
        // ],
        // mastery: [
        //   { required: true, message: "请选择技术成熟度", trigger: "change" }
        // ],
        // advanced: [
        //   { required: true, message: "请选择技术先进度", trigger: "change" }
        // ],
        pubdate: [
          {
            required: true,
            message: "请选择发布时间",
            trigger: "change",
          },
        ],
        people: [
          {
            required: true,
            message: "请输入联系人",
            trigger: "blur",
          },
        ],
        phone: [
          {
            required: true,
            message: "请输入联系电话",
            trigger: "blur",
          },
        ],
        introduction: [
          {
            required: true,
            message: "请输入科技成果简介",
            trigger: "blur",
          },
        ],
        hotOrder: [
          {
            required: true,
            validator: validateHoto,
            trigger: "blur",
          },
        ],
        keyName: [
          {
            required: true,
            message: "请选择关键字",
            trigger: "change",
          },
        ],
      },
      sourceLists: [],
    };
  },
  created() {
    this.getTrees()
    this.getData("Resource_Gain?all=1&isShow=1&page=" + this.current_page);
    this.getKey();
    this.getTree();
  },
  methods: {
    //行业分类
    getTrees(){
      // this.http.get('/trade/tree').then(res=>{
      this.http.get(`${urlConfig.devUrl}apij2/admin-api/trade/dic-trade/Recursion`).then(res=>{
        if(res.code == 0){
          this.sortOptions = res.data
        }
      })
    },
    // release(row,type){
    //   let obj = {};
    //   obj.id = row.id;
    //   obj.type = 5;
    //   obj.hot = 1;
    // },

    // 获取关键词

    async getTopKey() {
      let str = this.GetTarg(this.ruleForm.introduction);
      let data = await this.http.post("/top5/key", { content: str });
      this.ruleForm.keyName = data.data.map((el) => el.key);
    },
    // 监听关键词变更
    changeKeyName(val) {
      if (val.length > 5) {
        this.$message.warning("最多5个关键词");
        this.ruleForm.keyName = val.slice(0, 5);
      }
    },
    formatName(ids, rootLists, typeId, typeVal) {
      if (!ids) {
        return "";
      }
      let idsArr = ids.split(",");
      let result = [];
      idsArr.map((item) => {
        let obj = rootLists.filter((el) => el[typeId] == item);
        result.push(obj[0][typeVal]);
      });
      return result.join(",");
    },
    getTree() {
      // this.http.get("Unit?all_sub=1").then((res) => {
      this.http.post(`${urlConfig.devUrl}apij2/admin-api/system/user-bind-unit/getListAndTree`, {}).then((res) => {
        if (res.code == 0) {
          this.staffsOptions = res.data.tree;
          this.sourceLists = res.data.list;
          if(this.staffsOptions){
            this.getTreeData(this.staffsOptions);
          }
        }
      });
    },

    getTreeData(data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].children.length < 1) {
          // children若为空数组，则将children设为undefined
          data[i].children = undefined;
        } else {
          // children若不为空数组，则继续 递归调用 本方法
          this.getTreeData(data[i].children);
        }
      }
      return data;
    },

    getKey() {
      // this.axios.get("Resource_Key?all=1").then((res) => {
      this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/resource-key/page`, {
        all: 1,
        pageSize: 1000
      }).then((res) => {
        if (res.code == 0) {
          this.Resource_Keys = res.data.data;
        }
      });
    },
    getData(url) {
      let params = {};
      if(url.indexOf('?') > -1){
        let urlParams = url.split('?')[1]?.split('&')
        urlParams.forEach(item => {
          params[item.split('=')[0]] = item.split('=')[1]
        })
      }

      this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/resource-gain/page`, params).then((res) => {
        if (res.code == 0) {
          this.tableData = res.data.data;
          this.total = res.data.total;
          this.per_page = res.data.per_page;
          this.current_page = res.data.current_page * 1;
        }
      });
    },
    //富文本
    getQuillData(val) {
      this.ruleForm.introduction = val;
    },
    //城市选择
    citySelected(e) {
      this.ruleForm.address = e;
    },
    //新增
    addEvent() {
      this.is_submit = true;

      if (this.$refs["ruleForm"]) {
        this.$refs["ruleForm"].resetFields();
      }
      this.dialogFormVisible = true;
      this.Title = "新增";
      this.fileList = [];
      this.ruleForm = {
        name: "",
        logo: "",
        image: "",
        address: {
          province: {
            value: "甘肃省",
          },
          city: {
            value: "兰州市",
          },
          area: {
            value: "城关区",
          },
        },
        detailed: "",
        trade: [],
        field: [],
        naturalArr: [],
        natural: "",
        naturalSecond: "",
        naturalThird: "",
        unit: "",
        unitProperties: "",
        isPerson: 1,
        type: [],
        way: [],
        mastery: [],
        advanced: [],
        pubdate: "",
        people: "",
        phone: "",
        introduction: "",
        isShow: 1,
        hot: 2,
        hotOrder: 0,
        keyName: "",
        levelId:[],
      };
    },
    //批量删除
    deleteAll() {
      if (this.deleteRow) {
        this.$confirm("此操作将批量删除, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
        })
          .then(() => {
            this.http
              .request(`${urlConfig.devUrl}apij2/admin-api/trade/resource-gain/batchDelete?ids=` + this.deleteRow, "", "delete")
              .then((res) => {
                if (res.code == 0) {
                  this.getData("Resource_Gain?all=1&isShow=1&page=1");
                  this.$message({
                    type: "success",
                    message: "删除成功",
                  });
                  this.ResetSearch([
                    "searchValue",
                    "fieldValue",
                    "tradeValue",
                    "wayValue",
                  ]);
                } else {
                  this.$message({
                    message: "失败！",
                    type: "error",
                  });
                }
              });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      } else {
        this.$message({
          type: "warning",
          message: "请选择删除的记录",
        });
      }
    },
    //搜索
    search() {
      this.current_page = 1;
      this.getData(
        "Resource_Gain?all=1&isShow=1&name=" +
          this.searchValue +
          "&page=" +
          this.current_page +
          (this.fieldValue ? "&field=" + this.fieldValue : "") +
          (this.tradeValue ? "&trade=" + this.tradeValue : "") +
          (this.naturalValue[2]
            ? "&naturalThird=" + this.naturalValue[2]
            : this.naturalValue[1]
            ? "&naturalSecond=" + this.naturalValue[1]
            : this.naturalValue[0]
            ? "&natural=" + this.naturalValue[0]
            : "") +
          (this.typeValue ? "&type=" + this.typeValue : "") +
          (this.wayValue ? "&way=" + this.wayValue : "")
      );
    },
    //选择
    selectionChange(selection) {
      this.deleteRow = "";
      if (selection.length != 0) {
        let arr = [];
        selection.forEach((item) => {
          arr.push(item.id);
        });
        this.deleteRow = arr.join(",");
      }
    },
    //编辑
    handleEdit(index, row) {
      this.is_submit = true;
      this.dialogFormVisible = true;
      this.Title = "编辑";
      row.detailed = row.address ? row.address.detailed : "";
      row.address = row.address
        ? row.address
        : {
            province: {
              value: "",
            },
            city: {
              value: "",
            },
            area: {
              value: "",
            },
          };
      this.ruleForm = JSON.parse(JSON.stringify(row));
      this.ruleForm.field = row.field ? row.field.split(",") : row.field;
      this.ruleForm.trade = row.trade ? row.trade.split(",") : row.trade;
      this.ruleForm.type = row.type ? row.type.split(",") : row.type;
      this.ruleForm.way = row.way ? row.way.split(",") : row.way;
      this.ruleForm.mastery = row.mastery
        ? row.mastery.split(",")
        : row.mastery;
      this.ruleForm.advanced = row.advanced
        ? row.advanced.split(",")
        : row.advanced;
      // this.ruleForm.natural = row.natural.split(",");
      // this.ruleForm.naturalSecond = row.naturalSecond.split(",");
      // this.ruleForm.naturalThird = row.naturalThird.split(",");
      this.ruleForm.naturalArr = row.naturalJson
        ? JSON.parse(row.naturalJson)
        : [];
      this.ruleForm.isPerson = row.isPerson;
      this.ruleForm.unitProperties = row.unitProperties;
      this.ruleForm.keyName = row.keyName ? row.keyName.split(",") : [];
      // this.ruleForm.levelId = row.levelId || [];
      this.ruleForm.levelId = [];
      if (row.oneLevelId) {
        this.ruleForm.levelId.push(row.oneLevelId);
      }
      if (row.twoLevelId) {
        this.ruleForm.levelId.push(row.twoLevelId);
      }
      if (row.threeLevelId) {
        this.ruleForm.levelId.push(row.threeLevelId);
      }
      this.fileList = [];
      if (row.image) {
        let arr = [];
        arr = row.image.split(",");
        arr.forEach((item, index) => {
          this.fileList.push({
            name: "download.jpg",
            url: this.imgUrl + item,
            store_result: item,
            uid: new Date().getTime() + index,
          });
        });
      }
    },
    //删除
    handleDelete(index, row) {
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.http
            .request(`${urlConfig.devUrl}apij2/admin-api/trade/resource-gain/delete?id=` + row.id, "", "delete")
            .then((res) => {
              if (res.code == 0) {
                this.getData(
                  "Resource_Gain?all=1&isShow=1&page=" + this.current_page
                );
                this.$message({
                  type: "success",
                  message: "删除成功",
                });
                this.ResetSearch([
                  "searchValue",
                  "fieldValue",
                  "tradeValue",
                  "wayValue",
                ]);
              } else {
                this.$message({
                  message: "失败！",
                  type: "error",
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //翻页
    handleCurrentChange(e) {
      this.getData(
        "Resource_Gain?all=1&isShow=1&name=" +
          this.searchValue +
          "&page=" +
          e +
          (this.fieldValue ? "&field=" + this.fieldValue : "") +
          (this.tradeValue ? "&trade=" + this.tradeValue : "") +
          (this.naturalValue[2]
            ? "&naturalThird=" + this.naturalValue[2]
            : this.naturalValue[1]
            ? "&naturalSecond=" + this.naturalValue[1]
            : this.naturalValue[0]
            ? "&natural=" + this.naturalValue[0]
            : "") +
          (this.typeValue ? "&type=" + this.typeValue : "") +
          (this.wayValue ? "&way=" + this.wayValue : "")
      );
    },
    //取消
    closeForm(name) {
      this.dialogFormVisible = false;
      this.$refs[name].resetFields();
    },
    //获取经纬度
    factory(name) {
      if (this.ruleForm.detailed) {
        this.$jsonp(
          "https://restapi.amap.com/v3/place/text?key=cd745e505b8ce710bfb566c298caba0c&keywords=" +
            this.ruleForm.detailed +
            "&city=" +
            this.ruleForm.address.city.value +
            "&children=1&offset=20&page=1&extensions=all"
        )
          .then((json) => {
            let arr = json.pois[0].location.split(",");
            this.ruleForm.longitude = arr[0];
            this.ruleForm.latitude = arr[1];
            this.subData(name);
          })
          .catch((err) => {
            this.is_submit = true;

            this.$message.error("未获取到经纬度,请查看地址是否完整");
            // this.subData(name)
          });
      } else {
        this.is_submit = true;
        this.$message.error("未获取到经纬度,请查看地址是否完整");
      }
    },
    subData(name) {
      let obj = JSON.parse(JSON.stringify(this.ruleForm));
      let arr = [];
      this.fileList.forEach((item) => {
        if (item.response) {
          arr.push(item.response.data.store_result);
        } else {
          arr.push(item.store_result);
        }
      });
      obj.image = arr.join(",");
      obj.address.detailed = this.ruleForm.detailed;
      obj.trade = obj.trade ? obj.trade.join(",") : obj.trade;
      obj.field = obj.field ? obj.field.join(",") : obj.field;
      obj.field_name = this.formatName(
        obj.field,
        this.fieldOptions,
        "value",
        "label"
      );
      obj.trade_name = this.formatName(
        obj.trade,
        this.typeOptions,
        "value",
        "label"
      );
      // obj.naturalArr = obj.naturalArr.join(",");
      obj.type = obj.type ? obj.type.join(",") : obj.type;
      // obj.type_name = this.formatName(obj.type,this.options2,'value','label')
      obj.way = obj.way ? obj.way.join(",") : obj.way;
      obj.way_name = this.formatName(obj.way, this.options2, "value", "label");
      obj.mastery = obj.mastery ? obj.mastery.join(",") : obj.mastery;
      obj.mastery_name = this.formatName(
        obj.mastery,
        this.options3,
        "value",
        "label"
      );
      obj.advanced = obj.advanced ? obj.advanced.join(",") : obj.advanced;
      obj.advanced_name = this.formatName(
        obj.advanced,
        this.options4,
        "value",
        "label"
      );
      obj.dateTime = new Date().format("yyyy-MM-dd hh:mm:ss");
      let area = [
        {
          name: "兰州市",
          id: "001",
        },
        {
          name: "嘉峪关市",
          id: "002",
        },
        {
          name: "金昌市",
          id: "003",
        },
        {
          name: "白银市",
          id: "004",
        },
        {
          name: "天水市",
          id: "005",
        },
        {
          name: "武威市",
          id: "006",
        },
        {
          name: "张掖市",
          id: "007",
        },
        {
          name: "酒泉市",
          id: "008",
        },
        {
          name: "平凉市",
          id: "009",
        },
        {
          name: "庆阳市",
          id: "010",
        },
        {
          name: "定西市",
          id: "011",
        },
        {
          name: "陇南市",
          id: "012",
        },
        {
          name: "临夏回族自治州",
          id: "013",
        },
        {
          name: "甘南藏族自治州",
          id: "014",
        },
      ];
      area.forEach((item) => {
        if (obj.address.city.value == item.name) {
          obj.area = item.id;
          obj.areaName = item.name;
        }
      });
      if (obj.hot == 2) {
        obj.hotOrder = 0;
      }
      let array = [],
        array1 = [],
        array2 = [];
      if (obj.naturalArr.length) {
        // obj.naturalArr.forEach((item)=>{
        //   array.push(item[0])
        //   item[1]?array1.push(item[1]):''
        //   item[2]?array2.push(item[2]):''
        // })
        array.push(obj.naturalArr[0]);
        obj.naturalArr[1] ? array1.push(obj.naturalArr[1]) : "";
        obj.naturalArr[2] ? array2.push(obj.naturalArr[2]) : "";
      }
      obj.natural = this.unique(array).join(",");
      obj.naturalName = this.formatName(
        obj.natural,
        this.sourceLists,
        "id",
        "name"
      );
      obj.naturalSecond = this.unique(array1).join(",");
      obj.naturalSecondName = this.formatName(
        obj.naturalSecond,
        this.sourceLists,
        "id",
        "name"
      );
      obj.naturalThird = this.unique(array2).join(",");
      obj.naturalThirdName = this.formatName(
        obj.naturalThird,
        this.sourceLists,
        "id",
        "name"
      );
      obj.naturalJson = JSON.stringify(obj.naturalArr);
      obj.keyName = obj.keyName.join(",");
      delete obj.detailed;
      delete obj.naturalArr;

      obj.oneLevelId = obj.levelId[0]
      obj.twoLevelId = obj.levelId[1]
      obj.threeLevelId = obj.levelId[2]
      delete obj.levelId

      if (!this.ruleForm.id) {
        this.http
          .post(`${urlConfig.devUrl}apij2/admin-api/trade/resource-gain/create`, obj)
          .then((res) => {
            if (res.code == 0) {
              this.getData("Resource_Gain?all=1&isShow=1&page=1");
              this.getKey();
              this.$message({
                type: "success",
                message: "新增成功",
              });
              this.dialogFormVisible = false;
              this.ResetSearch([
                "searchValue",
                "fieldValue",
                "tradeValue",
                "wayValue",
              ]);

              this.$refs[name].resetFields();

              let obj1 = {
                name: obj.name,
                moudle: "科技成果",
                date_time: obj.dateTime,
              };
              // this.http.post("Index_Resource", obj1);
              this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/index-resource/create`, obj1);
            } else {
              this.is_submit = true;
            }
          })
          .catch((err) => {
            this.is_submit = true;
          });
      } else {
        // delete obj.id;
        // delete obj.dateTime;
        this.http
          .post(`${urlConfig.devUrl}apij2/admin-api/trade/resource-gain/update`, obj)
          .then((res) => {
            if (res.code == 0) {
              this.getData("Resource_Gain?all=1&isShow=1&page=1");
              this.getKey();
              this.$message({
                type: "success",
                message: "编辑成功",
              });
              this.ResetSearch([
                "searchValue",
                "fieldValue",
                "tradeValue",
                "wayValue",
              ]);

              this.dialogFormVisible = false;
              this.$refs[name].resetFields();
            } else {
              this.is_submit = true;
            }
          })
          .catch((err) => {
            this.is_submit = true;
          });
      }
    },
    //提交
    submitForm(name) {
      if (!this.is_submit) return false;
      this.is_submit = false;
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.factory(name);
        } else {
          this.is_submit = true;

          return false;
        }
      });
    },
    //数组去重
    unique(arr) {
      return arr.filter((ele, index, array) => {
        return array.indexOf(ele) === index;
      });
    },
    //上传图片
    HouImgFile(e) {
      var files = e.file;
      if (!files) return;
      this.createImage(files, e, "HouImg");
    },
    //其他图片上传
    createImage(file, e, Name) {
      //lrz压缩
      // lrz图片先压缩在加载、
      lrz(file, {
        width: 960,
      })
        .then((rst) => {
          this.http
            .post("/file/base64_upload", {
              image: rst.base64,
            })
            .then((res) => {
              this.ruleForm.logo = res.data;
            });
          return rst;
        })
        .always(() => {
          // 清空文件上传控件的值
          e.target.value = null;
        });
    },
    handlePictureCardPreview(file) {
      this.ruleForm.logo = file.data.store_result;
    },
    beforeAvatarUpload(file) {
      let type = false;
      if (
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg" ||
        file.type === "image/gif" ||
        file.type === "image/bmp"
      ) {
        type = true;
      }

      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!type) {
        this.$message.error("上传图片只能是 JPEG/jpg/png/gif/bmp 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 10MB!");
      }
      return type && isLt2M;
    },
    deleteImg() {
      this.$confirm("确定删除图片吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.ruleForm.logo = "";
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //上传照片墙
    HouImgFile1(e) {
      var files = e.file;
      if (!files) return;
      this.createImage1(files, e, "HouImg");
    },
    //其他图片上传
    createImage1(file, e, Name) {
      //lrz压缩
      // lrz图片先压缩在加载、
      lrz(file, {
        width: 960,
      })
        .then((rst) => {
          this.http
            .post("/file/base64_upload", {
              image: rst.base64,
            })
            .then((res) => {
              this.fileList.push({
                name: file.name,
                url: this.imgUrl + res.data,
                store_result: res.data,
                uid: file.uid,
              });
            });
          return rst;
        })
        .always(() => {
          // 清空文件上传控件的值
          e.target.value = null;
        });
    },
    //移除
    handleRemove1(file, fileList) {
      this.fileList = fileList;
    },
    //上传前
    beforeUpload1(file) {
      let type = false;
      if (
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg" ||
        file.type === "image/gif" ||
        file.type === "image/bmp"
      ) {
        type = true;
      }

      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!type) {
        this.$message.error("上传图片只能是 JPEG/jpg/png/gif/bmp 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 10MB!");
      }
      return type && isLt2M;
    },
    //查看
    pictureCardPreview1(file, fileList) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
  },
};
</script>
<style lang="scss" scope>
.gain {
  height: 100%;
  width: 100%;

  .research-search {
    width: 100%;
    text-align: left;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .el-select {
      margin: 0 15px;

      .el-input {
        margin: 0;
      }
    }

    .el-cascader {
      margin: 0 15px;

      .el-input {
        margin: 0;
      }
    }

    /deep/.el-input--suffix {
      width: 100%;
    }

    .el-input {
      margin: 0 15px;
    }

    .date-picker {
      margin: 0 15px;

      .el-range-separator {
        width: auto;
      }
    }
  }

  .research-table {
    width: 100%;
    margin-top: 20px;
    border: 1px solid #eef1f6;
  }

  /*上传图片*/
  .is_border {
    border: 1px dashed #ddd !important;
    border-radius: 5px;
    height: 154px !important;
    line-height: 154px !important;
  }

  .upload_btn {
    display: block;
    background-color: #00a1ff;
    font-weight: bold;
    color: #fff;
    padding: 2px;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
  }

  .upload_btn:hover {
    background-color: #13ce66;
  }

  .del_img {
    position: absolute;
    top: -7px;
    left: 224px;
    color: #00a1ff;
  }

  .del_img:hover {
    cursor: pointer;
    color: #f00;
  }

  .del_img i:before {
    font-size: 20px;
  }

  .img_border {
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    width: 243px;
    height: 154px;
    display: block;
  }

  .avatar-uploader {
    text-align: center;
    width: 243px;
    height: 198px;
  }

  /deep/ .el-upload {
    border: 1px dashed #d9d9d9 !important;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  /deep/ .el-upload:hover {
    border-color: #409eff !important;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 243px;
    height: 154px;
    line-height: 154px;
    text-align: center;
  }
}
</style>
